import { ChangeDetectionStrategy, Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Subject } from 'rxjs';

import { GlassGlowDirective } from '../../../fuse/directives/glass-glow/glass-glow.directive';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'empty-layout',
  templateUrl: './empty.component.html',
  styleUrls: ['./empty.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [RouterModule, GlassGlowDirective]
})
export class EmptyLayoutComponent implements OnDestroy {
  private _unsubscribeAll: Subject<void> = new Subject<void>();
  /**
   * Constructor
   */
  constructor() {}
  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
